import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV_LINKS } from "@/lib/brand";

export function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header
      data-testid="site-navbar"
      className="fixed top-0 w-full z-50 bg-ivory/80 backdrop-blur-md border-b border-champagne/20"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between h-20">
        <Link to="/" data-testid="nav-logo" className="flex flex-col leading-none">
          <span className="font-serif text-2xl text-espresso tracking-tight whitespace-nowrap">people, redefined.</span>
          <span className="hidden xl:block text-[10px] tracking-[0.25em] text-gold mt-0.5 whitespace-nowrap">
            rethinking hr. redefining opportunity.
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-7">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.to === "/" ? "home" : l.to.slice(1)}`}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors ${
                  isActive ? "text-gold" : "text-espresso hover:text-gold"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/book"
            data-testid="nav-book-consultation"
            className="bg-espresso text-ivory rounded-full px-6 py-2.5 text-sm font-medium hover:bg-forest transition-colors duration-300"
          >
            Book a Consultation
          </Link>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          className="lg:hidden text-espresso"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div data-testid="nav-mobile-menu" className="lg:hidden bg-ivory border-t border-champagne/20 px-6 py-6 flex flex-col gap-4">
          {NAV_LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              data-testid={`nav-mobile-link-${l.to === "/" ? "home" : l.to.slice(1)}`}
              className={`text-base font-medium ${location.pathname === l.to ? "text-gold" : "text-espresso"}`}
            >
              {l.label}
            </Link>
          ))}
          <Link
            to="/book"
            onClick={() => setOpen(false)}
            data-testid="nav-mobile-book"
            className="bg-espresso text-ivory rounded-full px-6 py-3 text-center font-medium mt-2"
          >
            Book a Consultation
          </Link>
        </div>
      )}
    </header>
  );
}
